import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class NNAWidget extends Component {
  // On component mount fire mount call back function.
  componentDidMount() {
    this.props.onComponentMountCallBack();
  }

  // Get component class names based on the componentName through props.
  // Customization to styling as this component is being called from different component levels.
  getWidgetClassName() {
    return classNames({
      'nna-widget': true,
      'minihelp-nna-widget': this.props.componentName === 'minihelp',
    });
  }

  // Render widget.
  render() {
    const {
      title, subTitle, buttonText, onClickHandler,
    } = this.props;
    return (
      <div className={this.getWidgetClassName()}>
        <div className="nna-widget--title">{title}</div>
        <div className="nna-widget--sub_label">{subTitle}</div>
        <button className="nna-widget--started_button" onClick={() => onClickHandler()}>
          {buttonText}
        </button>
      </div>
    );
  }
}

NNAWidget.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  buttonText: PropTypes.string,
  onClickHandler: PropTypes.func,
  componentName: PropTypes.string,
  onComponentMountCallBack: PropTypes.func,
};

export default NNAWidget;
